import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { Badge, Tooltip } from '@mui/material'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { ColorTokens } from 'src/feature/theme/model/Palette'

export type AssistantLauncherProps = {
  isOpen: boolean;
  title: string;
  messageCount: number;
  onToggle: () => void;
};

export function AssistantLauncher({
  isOpen,
  title,
  messageCount,
  onToggle,
}: AssistantLauncherProps) {
  return (
    <Tooltip title={isOpen ? '' : title} placement="left">
      <AppBox sx={styles.fabAnchor}>
        <Badge
          badgeContent={
            messageCount === 0 ? (
              <AppBox sx={styles.zeroBadge}>
                {[0, 1, 2].map(index => (
                  <AppBox
                    key={index}
                    sx={[
                      styles.zeroBadgeDot,
                      { animationDelay: `${index * 0.16}s` },
                    ]}
                  />
                ))}
              </AppBox>
            ) : (
              messageCount
            )
          }
          max={99}
          overlap="circular"
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={styles.badge}
        >
          <AppBox sx={styles.fab} onClick={onToggle}>
            {isOpen ? (
              <CloseRoundedIcon sx={{ fontSize: 25, color: 'white' }} />
            ) : (
              <AutoAwesomeRoundedIcon sx={{ fontSize: 25, color: 'white' }} />
            )}
          </AppBox>
        </Badge>
      </AppBox>
    </Tooltip>
  )
}

const styles = {
  fab: {
    width: 45,
    height: 45,
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${ColorTokens.primary500}, #2a9d8f)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(54, 187, 175, 0.4)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      transform: 'scale(1.08)',
      boxShadow: '0 6px 24px rgba(54, 187, 175, 0.55)',
    },
  },
  fabAnchor: {
    position: 'fixed',
    bottom: 25,
    right: 25,
    zIndex: 1300,
  },
  badge: {
    position: 'relative',
    '& .MuiBadge-badge': {
      zIndex: 2,
      top: 6,
      right: 6,
      minWidth: 18,
      height: 18,
      borderRadius: 9,
      padding: '0 5px',
      backgroundColor: ColorTokens.red100,
      color: 'white',
      fontSize: 10,
      fontWeight: 600,
      boxShadow: '0 0 0 2px white',
    },
  },
  zeroBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    width: 18,
    height: 18,
  },
  zeroBadgeDot: {
    width: 3,
    height: 3,
    borderRadius: '50%',
    backgroundColor: 'white',
    animation: 'assistant-dot-pulse 1s ease-in-out infinite',
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
    '@keyframes assistant-dot-pulse': {
      '0%, 80%, 100%': {
        transform: 'translateY(0) scale(0.7)',
        opacity: 0.6,
      },
      '40%': {
        transform: 'translateY(-2px) scale(1)',
        opacity: 1,
      },
    },
  },
}
